import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class DateTimePickerYears extends Component {
  renderYears = () => {
    const years = [];

    let year = parseInt(this.props.viewDate.year() / 10, 10) * 10 - 1;
    let startYear = year;
    let i = -1;

    while (i < 11) {
      let yearInDecade = startYear + 1 + i;
      let yearBeforeMinDate = this.props?.minDate
        ? yearInDecade < this.props.minDate.year()
        : false;
      let yearAfterMaxDate = this.props?.maxDate
        ? yearInDecade > this.props.maxDate.year()
        : false;
      let disabled = yearBeforeMinDate || yearAfterMaxDate;
      const tabIndex = disabled ? undefined : 0;

      let classes = {
        year: true,
        old: (i === -1) | (i === 10),
        active: this.props.selectedDate.year() === year,
        // disabled // This will disable cells that are below the min date or above the max date, and make them disabled. Possibly going too far to enable this
      };
      years.push(
        <span
          className={classnames(classes)}
          key={year}
          onClick={this.props.setViewYear}
          data-test-id="datepicker-year--cell"
          tabIndex={tabIndex}
        >
          {year}
        </span>
      );
      year++;
      i++;
    }
    return years;
  };

  render() {
    const tabIndex = this.props.onShow ? '0' : undefined;
    const year = parseInt(this.props.viewDate.year() / 10, 10) * 10;

    return (
      <div className="datepicker-years" style={{ display: 'block' }}>
        <table
          className="table-condensed"
          data-test-id="datepicker--years-grid"
        >
          <thead>
            <tr>
              <th
                className="prev"
                onClick={this.props.subtractDecade}
                aria-label="Previous decade"
                tabIndex={tabIndex}
                data-test-id="datepicker-prev--decade"
              >
                ‹
              </th>

              <th className="switch" colSpan="5">
                {year} - {year + 9}
              </th>

              <th
                className="next"
                onClick={this.props.addDecade}
                aria-label="Next decade"
                tabIndex={tabIndex}
                data-test-id="datepicker-next--decade"
              >
                ›
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan="7">{this.renderYears()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

DateTimePickerYears.propTypes = {
  addDecade: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onShow: PropTypes.bool.isRequired,
  selectedDate: PropTypes.object.isRequired,
  setViewYear: PropTypes.func.isRequired,
  subtractDecade: PropTypes.func.isRequired,
  viewDate: PropTypes.object.isRequired,
};

export default DateTimePickerYears;
